import "./UnitPicker.scss"

import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import { Guid } from "@/types"
import { useUnits } from "stores/units"
import UnitPickerModal from "./UnitPickerModal"
import Unit from "models/Unit"

interface IUnitPickerProps {
    unitId?: Guid
    onChange: (unit: Unit) => void
}

const UnitPicker: FC<IUnitPickerProps> = ({
    unitId,
    onChange,
}) => {
    const { t } = useTranslation()
    const { units, getUnit } = useUnits()
    const currentUnit = getUnit(unitId)
    const [showUnitChangeModal, setShowUnitChangeModal] = useState(false)

    if (!units || units.length === 0) return null

    return (
        <>
            <button
                type="button"
                className="unit-picker"
                onClick={() => setShowUnitChangeModal(true)}>
                {currentUnit ? currentUnit.print() : t('common.pleaseSelect')}
            </button>
            {showUnitChangeModal &&
                <UnitPickerModal
                    units={units}
                    defaultUnit={currentUnit}
                    onClose={() => setShowUnitChangeModal(false)}
                    onChange={onChange} />
            }
        </>
    )
}

export default UnitPicker
